import type { SVGProps } from 'react';

const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 2C6.77454 1.99188 2.42385 6.00828 2.01506 11.2177C1.60628 16.4271 5.27723 21.073 10.44 21.88V14.88H7.89995V12H10.44V9.8C10.3268 8.75905 10.6829 7.72176 11.4116 6.96986C12.1403 6.21796 13.166 5.8295 14.21 5.91C14.9602 5.9198 15.7088 5.98329 16.45 6.1V8.56H15.19C14.7554 8.50406 14.3188 8.64763 14.0023 8.95058C13.6857 9.25354 13.5231 9.68339 13.56 10.12V12H16.34L15.89 14.89H13.56V21.89C18.754 21.1144 22.4631 16.4533 22.0525 11.2177C21.6419 5.98223 17.2514 1.95633 12 2Z" />
  </svg>
);
export default SvgFacebook;
